import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { CAREERS } from "../../data/site";
import { toast } from "sonner";

export default function Careers() {
  const onApply = (role) => {
    toast.success("Application interest captured", {
      description: `Email your CV to info@mbprism.com referencing “${role}”. We respond within 5 business days.`,
      duration: 5000,
    });
  };
  return (
    <section
      id="careers"
      data-testid="careers-section"
      className="py-24 md:py-36 bg-white border-t border-black/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-6 h-px bg-[#FF331F]" />
              <span className="font-mono-ibm text-[11px] tracking-[0.2em] uppercase text-[#FF331F]">
                Careers / 05
              </span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.05] font-medium">
              Senior practice.
              <br />
              Open roles.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 lg:pt-4">
            <p className="text-lg text-[#404040] leading-relaxed">
              We hire people who can hold a room of stakeholders and write
              production code in the same week. All roles are fully remote
              across Canada.
            </p>
          </div>
        </div>

        <div className="border-t border-black/15">
          {CAREERS.map((c, i) => (
            <motion.div
              key={c.id}
              data-testid={`career-row-${c.id}`}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className="group grid grid-cols-12 items-center gap-4 py-6 md:py-8 border-b border-black/15 hover:bg-black/[0.02] transition-colors"
            >
              <div className="col-span-12 md:col-span-5 font-display text-2xl md:text-3xl tracking-tight leading-tight">
                {c.role}
              </div>
              <div className="col-span-6 md:col-span-3 text-sm text-[#404040]">
                {c.location}
              </div>
              <div className="col-span-6 md:col-span-2 font-mono-ibm text-xs uppercase tracking-widest text-[#0A0A0A]">
                {c.type}
              </div>
              <div className="col-span-12 md:col-span-2 flex md:justify-end">
                <button
                  data-testid={`career-apply-${c.id}`}
                  onClick={() => onApply(c.role)}
                  className="inline-flex items-center gap-2 text-sm font-medium px-4 py-2 border border-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white transition-colors"
                >
                  Apply
                  <ArrowUpRight
                    size={16}
                    className="group-hover:rotate-45 transition-transform"
                  />
                </button>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-10 font-mono-ibm text-xs text-[#404040]">
          Not seeing a fit? Send a note to{" "}
          <a
            href="mailto:info@mbprism.com"
            className="underline underline-offset-4 hover:text-[#FF331F]"
            data-testid="careers-mailto"
          >
            info@mbprism.com
          </a>
          .
        </div>
      </div>
    </section>
  );
}
